import {
  getSearchDataService,
  openModalService,
  resetStorageData,
} from "@/stories/Components/CruiseItineraryDetail/store/services/modalInteractionService";

const state = {
  searchData: null,
  langData: null,
  showModal: false,
};
const getters = {
  searchData: (state) => state.searchData,
  itinerary: (state) => state.itinerary,
  langData: (state) => state.langData,
  showModal: (state) => state.showModal,
};
const actions = {
  trackSearchDate({ commit, dispatch }) {
    getSearchDataService()
      .then((data) => {
        commit("setSearchData", data);
      })
      .catch(() => {
        dispatch("closeModal");
      });
  },
  openModal({ commit, dispatch }) {
    openModalService()
      .then((data) => {
        commit("setShowModalFlag", data);
      })
      .catch(() => {
        dispatch("closeModal");
      });
  },
  closeModal({ commit }) {
    resetStorageData();
    commit("setShowModalFlag", false);
  },
  getItineraryData() {
    // sending itinerary endpoint
  },
  getLangData() {
    // sending lang data endpoint
  },
  setShowModalFlagInStorybook({ commit }, payload) {
    commit("setShowModalFlag", payload);
  },
};
const mutations = {
  setSearchData(state, payload) {
    this.state.searchData = payload;
  },
  setShowModalFlag(state, payload) {
    state.showModal = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
